module.exports = ".row{\r\n    padding:14px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.margin-top{\r\n    margin-top: 24px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-form/variable-deduction-form.component.css
// module id = ./src/app/hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-form/variable-deduction-form.component.css
// module chunks = main